import Application, { mountComponent, mountDialog } from './Application';
import Subscription from './Subscription';

document.addEventListener('DOMContentLoaded', () => {
    mountComponent('root', Application);
    mountComponent('subscription', Subscription);
    mountDialog('write');
});